export default function SVG_Intro() {
  return (
    <div>
      <h1>SVG_Intro Component</h1>
    </div>
  );
}
